import { TINT_PRICE_IN_RUB } from 'features/product-info/components/pdp-select-tint-color/pdp-select-tint-color.const';

export const handleChangePriceInRobotintModal = (
  priceElement: HTMLElement[],
  tintDataObject: {
    BASE_TYPE_INT: number;
  },
) => {
  const A_BASE_FOR_PAINT_VALUE = 1;
  const C_BASE_FOR_PAINT_VALUE = 3;

  const { BASE_TYPE_INT } = tintDataObject;

  let tintPriceText: string;

  switch (BASE_TYPE_INT) {
    case A_BASE_FOR_PAINT_VALUE:
      tintPriceText = `\n${TINT_PRICE_IN_RUB.TINT_SERVICE_ID_FOR_BASE_A_PAINT} ₽/л\n`;
      break;
    case C_BASE_FOR_PAINT_VALUE:
      tintPriceText = `\n${TINT_PRICE_IN_RUB.TINT_SERVICE_ID_FOR_BASE_C_PAINT} ₽/л\n`;
      break;
    default:
      tintPriceText = '';
  }

  priceElement[0].textContent = tintPriceText;
};
